import * as React from 'react';
import { Link, Text } from '@dropbox/dig-components/typography';
import { IconButton } from '@dropbox/dig-components/buttons';
import { ListViewLine } from '@dropbox/dig-icons/assets';
import { UIIcon } from '@dropbox/dig-icons';
/**
 * Links used to display local navigation items
 */
export const LocalNavLink = ({ children, ...rest }) => (React.createElement(Text, { size: "medium" },
    React.createElement(Link, { ...rest, hasNoUnderline: true, inverse: true, className: "dpc-GlobalHeader-Local-Nav__link" }, children)));
/**
 * Container housing LocalNavLinks, in which we limit to three items.
 *
 * When we're in a mobile view (determined with media-queries), the
 * localy nav hides LocalNavLinks inside it's container and displays the
 * Hamburger IconButton instead.
 *
 * Note: Mobile menu is not implemented and is suggested to follow File's
 * lead on implementation until something is in place here.
 */
export const LocalNavigation = ({ children, ariaLabel, mobileTriggerProps }) => {
    return (React.createElement("nav", { className: "dpc-GlobalHeader-Local-Nav" },
        React.createElement("div", { className: "dpc-GlobalHeader-Local-Nav__hamburger" },
            React.createElement(IconButton, { ...mobileTriggerProps, variant: "transparent" },
                React.createElement(UIIcon, { src: ListViewLine, "aria-label": ariaLabel }))),
        React.createElement("div", { className: "dpc-GlobalHeader-Local-Nav__children" }, children)));
};
LocalNavigation.displayName = 'LocalNavigation';
